import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-help-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './help-modal.component.html',
  styleUrl: './help-modal.component.scss'
})
export class HelpModalComponent {
  @Input() title: string = '';
  @Input() cancelButtonText: string = '';
  @Input() saveButtonText: string = '';
  @Input() showCancelButton: boolean = true;
  @Input() showSaveButton: boolean = true;
  @Input() modalBody!: TemplateRef<any>;


  constructor(public activeModal: NgbActiveModal) {}

  save(): void {
    this.activeModal.close(true);
  }

  cancel(): void {
    this.activeModal.dismiss(false);
  }
}
